export enum AIStatus {
  pausedFull = "paused-full",
  pausedNewcontacts = "paused-newcontacts",
  active = "active",
}

export const aiStatusAsString = (aiStatus: AIStatus): string => {
  switch (aiStatus) {
    case AIStatus.pausedFull:
      return "🚫 En pause";
    case AIStatus.pausedNewcontacts:
      return "🚫 En pause partielle (nouveaux contacts non engagés)";
    case AIStatus.active:
      return "🟢 Active";
    default:
      return "";
  }
};

export const aiStatusAsMinimalString = (aiStatus: AIStatus): string => {
  switch (aiStatus) {
    case AIStatus.pausedFull:
      return "Pause totale";
    case AIStatus.pausedNewcontacts:
      return "Pause partielle";
    case AIStatus.active:
      return "Active";
  }
};